const RecommendationsIcon = () => {
    return (
        <svg
            width={16}
            height={17}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <mask
                id="mask0_24_13748"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x={0}
                y={0}
                width={16}
                height={17}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.27999 2.41205C7.35335 2.28615 7.45845 2.1817 7.58478 2.1091C7.71112 2.0365 7.85428 1.99829 7.99999 1.99829C8.1457 1.99829 8.28886 2.0365 8.4152 2.1091C8.54153 2.1817 8.64663 2.28615 8.71999 2.41205L10.5833 5.61071L14.202 6.39471C14.3443 6.42565 14.4761 6.49335 14.5841 6.59107C14.6921 6.68879 14.7726 6.81312 14.8176 6.95166C14.8626 7.09021 14.8705 7.23812 14.8405 7.38066C14.8105 7.5232 14.7437 7.65539 14.6467 7.76405L12.18 10.5247L12.5533 14.208C12.5681 14.3531 12.5445 14.4994 12.4849 14.6325C12.4254 14.7656 12.332 14.8807 12.2141 14.9664C12.0961 15.0521 11.9578 15.1054 11.8128 15.1209C11.6679 15.1363 11.5214 15.1135 11.388 15.0547L7.99999 13.5614L4.61199 15.0547C4.4786 15.1135 4.33212 15.1363 4.18716 15.1209C4.0422 15.1054 3.90385 15.0521 3.7859 14.9664C3.66796 14.8807 3.57457 14.7656 3.51504 14.6325C3.45551 14.4994 3.43193 14.3531 3.44666 14.208L3.81999 10.5247L1.35332 7.76471C1.25614 7.65606 1.18916 7.52382 1.15907 7.38119C1.12897 7.23856 1.13682 7.09053 1.18182 6.95188C1.22682 6.81323 1.30741 6.68882 1.41553 6.59105C1.52365 6.49328 1.65553 6.42558 1.79799 6.39471L5.41666 5.61071L7.27999 2.41205ZM7.99999 3.82471L6.45799 6.47271C6.39968 6.57266 6.3212 6.65937 6.22754 6.72732C6.13388 6.79527 6.0271 6.84297 5.91399 6.86738L2.91932 7.51605L4.96066 9.80071C5.11666 9.97538 5.19199 10.2074 5.16866 10.44L4.85999 13.4887L7.66399 12.2527C7.76987 12.2061 7.88429 12.182 7.99999 12.182C8.11569 12.182 8.23011 12.2061 8.33599 12.2527L11.14 13.4887L10.8313 10.44C10.8196 10.3249 10.832 10.2086 10.8677 10.0986C10.9034 9.98848 10.9616 9.88704 11.0387 9.80071L13.0807 7.51605L10.086 6.86738C9.97288 6.84297 9.8661 6.79527 9.77244 6.72732C9.67878 6.65937 9.6003 6.57266 9.54199 6.47271L7.99999 3.82471Z"
                    fill="#A0AEC0"
                />
            </mask>
            <g mask="url(#mask0_24_13748)">
                <rect y="0.5" width={16} height={16} fill="#A0AEC0" />
            </g>
        </svg>

    );
}

export default RecommendationsIcon;